import React, { Component } from 'react';
import { Route, Switch, withRouter } from "react-router-dom";
import { Field, reduxForm, FieldArray } from 'redux-form'
import { Col, Row, Button, FormGroup } from 'reactstrap';
import { Preloading } from '../../../../../components/UI/Preloader/action';
import { connect } from 'react-redux';
import Modal from '../../../../../components/UI/Modal/Modal'
import { getCounterpartyType } from '../../../../../Analyst/Cases/Create/actions';
import {addDefaultProducts} from '../../action';
import {DOMESTIC, INTERNATIONAL} from '../../../../../Analyst/Cases/constants'

const required = value => value ? null : 'Required';

const renderMembers = ({ fields, counterPartyTypeDropdown, meta: { error, submitFailed } }) => (
    <ul>
        {fields.map((member, index) => (
            <li key={index}>
                <Row className="d-flex align-items-center mb-3 pl-3">
                <Col sm="10" className="px-2">
                    <div>
                            <label>
                                <Field name={`${member}.productGeography`} component="input" type="radio" value={DOMESTIC} validate={[required]}/>{' '}
                                Domestic
                            </label>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <label>
                                <Field name={`${member}.productGeography`} component="input" type="radio" value={INTERNATIONAL}  validate={[required]}/>{' '}
                                International
                            </label>
                    </div>
                </Col>
                <Col sm="11" className="px-2">
                    <Field name={`${member}.counterpartyType`} component="select" className="form-control dropdown-counterparty border" validate={[required]}>
                        <option value=''>Select</option>
                        {
                            counterPartyTypeDropdown.map(p => {
                                return (
                                    <option key={p} value={p}>{p}</option>
                                )
                            })
                        }
                    </Field>
                </Col>
                <Col sm="2" className="px-2 text-right"><a onClick={() => fields.remove(index)}><i className="icon-close text-danger pointer"></i></a> </Col>
                </Row>
            </li>
        ))}
        <Row>
            <Button type="button" className="d-flex ml-auto text-primary text-decoration-none pr-4 pt-0" color="link" onClick={() => fields.push({})}><i className="icon-plus mr-2 text-decoration-none"></i>Add More</Button>
        </Row>

    </ul>
)

class AddDefaultProducts extends Component {
    constructor(props) {
        super(props);
        this.state = {
                      resizeZIndex: false,
                      showModal: false
                    }

    }

    getInitialModalState = () => ({
        showWarning: "",
        warning: "",
        failed: false,
        body: <form className="modal-content shadow-none border-0" onSubmit={(e) => this.handleOnboardFormSubmit(e)}><br/>
                
            <Row className="mb-2 pl-3">
                <Col sm="10" className="px-2"><label>Product Geography&nbsp;<span className="text-danger">*</span></label></Col>
                <Col sm="10" className="px-2"><label>Counterparty Type&nbsp;<span className="text-danger">*</span></label></Col>
            </Row>

            <FieldArray name="geoAndTypeCombo" counterPartyTypeDropdown= {this.props.counterPartyTypeDropdown} component={renderMembers} />
                <br/>
                <Button type="submit" color="primary" >ADD</Button>
        </form>
    })

    componentDidMount() {
        this.setState(this.getInitialModalState())
        this.props.fetchCounterPartyType();
        this.props.initialize({
            "geoAndTypeCombo": [{}]
        })
    }

    componentDidUpdate(prevProps) {
        if(this.props.showAddDefaultProductsModal !== prevProps.showAddDefaultProductsModal) {
            this.setState(prevState => ({showModal: !prevState.showModal}))
            this.setState(this.getInitialModalState())
            this.props.reset()
        }

        //for success response
        if (!this.props.defaultProductsAddedResponse.error && this.props.defaultProductsAddedResponse !== prevProps.defaultProductsAddedResponse) {     
            this.setState({ resizeZIndex: false })
            this.props.preloading(false)
            window.location.reload();

        }

        //for failure response
        else if (this.props.defaultProductsAddedResponse.error && this.props.defaultProductsAddedResponse !== prevProps.defaultProductsAddedResponse) {
            this.setState({ resizeZIndex: false })
            this.props.preloading(false)
            this.setState({
                failed: true,
                body: <div className="modal-body">
                    <h5 className="text-danger"><i className="fa fa-exclamation-triangle">&nbsp;</i>Failure</h5>
                    <h5>Failure in adding default products!</h5>
                    <h5>{(this.props.defaultProductsAddedResponse.error.response && this.props.defaultProductsAddedResponse.error.response.data) ? this.props.defaultProductsAddedResponse.error.response.data.message : "Something went wrong! Please try again."}</h5><br/>
                    <Button color="info" onClick={this.handleOk}>OK</Button>
                </div>
            })
        }
    }

    handleOnboardFormSubmit = (event) => {
        event.preventDefault()
        if (event.target.elements.length < 5) {
            this.setState({
                showWarning: "true",
                warning: "There should be atleast one product geography and counterparty type"})
            }
        
        else if(this.checkFormValues(event.target.elements)) {
            this.setState({
                showWarning: "true",
                warning: "All fields are mandatory"})
        }
        else{
            let request = this.createRequest(event.target.elements)
            console.log(request)
            this.props.addDefaultProductsToCorporate(request)
            this.props.preloading(true)
            this.setState({ resizeZIndex: true })
        }
        

    }

    checkFormValues = (elems) => {
        let comboLength = (elems.length-2) / 3
        for(let i = 0; i< comboLength; i++) {
            if(!elems[`geoAndTypeCombo[${i}].productGeography`].value || !elems[`geoAndTypeCombo[${i}].counterpartyType`].value) {
                return true;
            }
        }
        return false;
    }

    createRequest = (elems) => {
        let productGeoAndCounterpartyTypeComboList = []
        let comboLength = (elems.length-2) / 3
        for(let i = 0; i< comboLength; i++) {
            productGeoAndCounterpartyTypeComboList[i] = {
                productGeography : elems[`geoAndTypeCombo[${i}].productGeography`].value,
                counterpartyType : elems[`geoAndTypeCombo[${i}].counterpartyType`].value
            }
        }
        return {
            corporateId: this.props.corporateId,
            productGeoAndCounterpartyTypeComboList
        }
    }

    handleOk = () => {
        window.location.reload();
    }

    handleCancel = () => {
        this.props.closeModal()      
    }

    reloadPage = () => {
        window.location.reload();
    }


    render() {
            let modalHeader = <div className="modal-header row pt-0">
            <h5 className="mb-0">Add Default Products</h5>
            <button type="button" onClick={this.state.failed ? this.reloadPage : this.handleCancel} className="close outline-none" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>;
        return (
            <Modal show={this.state.showModal} className={this.state.resizeZIndex ? 'z-index-zero Large-Modal modal-content' : 'Large-Modal modal-content'} modalClosed={this.handleModal} >
                    {modalHeader}
                    {this.state.showWarning && <strong className="text-danger">{this.state.warning}</strong>}
                    {this.state.body}
                </Modal>
        )
    }
}
const mapStateToProps = (state) => ({
    counterPartyTypeDropdown: state.createCase.dropdownData,
    defaultProductsAddedResponse: state.corporateOnBoardingCreate.defaultProductsAddedResponse
});

const mapDispatchToProps = (dispatch) => ({
    addDefaultProductsToCorporate : (data) => dispatch(addDefaultProducts(data)),
    fetchCounterPartyType: () => dispatch(getCounterpartyType()),
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); }
});

export default reduxForm({
    form: 'AddDefaultProducts'
})(connect(mapStateToProps, mapDispatchToProps)(AddDefaultProducts))